import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {loadSiteConfig} from '../config';
import {getNodeId} from "../../../../util/Util";
import Container from "react-bootstrap/Container";

class LedTesterNavBar extends React.Component {
    constructor(props) {
        super(props);
        this.selectedTitle = "Bin";
        this.state = {
            siteId: getNodeId(),
        };
    }

    async updateSiteId(siteId) {
        this.setState({siteId});
        this.props.onSiteConfigChange(await loadSiteConfig(siteId));
        this.props.onSiteIdChange(siteId);
    }

    render() {
        return <Navbar bg="dark" variant="dark">
            <Container>
                <Navbar.Brand>{this.selectedTitle}</Navbar.Brand>
                <Nav className="mr-auto">
                    <Nav.Link>
                        <div onClick={() => {this.props.onNavChange('cluster');this.selectedTitle="Cluster"} }>Cluster</div>
                    </Nav.Link>

                    <Nav.Link>
                        <div onClick={() => {this.props.onNavChange('controller'); this.selectedTitle="Led Controller" }}>Led Controller</div>
                    </Nav.Link>

                    <Nav.Link>
                        <div onClick={() => {this.props.onNavChange('bin'); this.selectedTitle="Bin"}}>Bin</div>
                    </Nav.Link>
                </Nav>
            </Container>
        </Navbar>
    }
}

export default LedTesterNavBar;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/component/navbar.jsx